<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
export default
{
    mixins: [ adminTable ],

    computed:
    {
        fullUrl()
        {
            return `${process.env.API_URL}${this.url}/table`
        }
    },

    data()
    {
        return {
            data: [],
            noFetch: true,
            url: '/v1/admin/users',
            tableName: 'tableUsers',
            emptyModel: { name: null, email: null, password: null, first_name: null, last_name: null, birthday: null, country: null, misc: null, role_id: 1, },
            columns: [ 'id', 'name', 'last_name', 'first_name', 'birthday', 'country', 'email', 'created_at', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    first_name: this.$t('USER.FIRST_NAME'),
                    last_name: this.$t('USER.LAST_NAME'),
                    birthday: this.$t('USER.BIRTHDAY'),
                    country: this.$t('USER.COUNTRY'),
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'email', 'first_name', 'last_name', 'birthday', 'country', 'created_at', ],
                sortable: ['id', 'name', 'first_name', 'last_name', 'birthday', 'email', 'created_at'],
                responseAdapter: res => {
                    return res && res.data ? {
                      data: res.data.data,
                      count: res.data.count,
                    } : { data: [], count: 0}
                },
            },
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('GENERAL.EDIT') }}</span>
            <mv-user-form :model="model" :edit="formEdit" ref="userform" @save="saveForm"></mv-user-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.USERS') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-server-table :url="fullUrl" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="name" slot-scope="props">
                        <mv-user-image :user="props.row" :size="16"></mv-user-image>
                        {{ props.row.name }}
                    </div>

                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                </v-server-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Users.vue